import { 
    GAME_FACT_BASKET_FAULT, 
    GAME_FACT_BASKET_FREETHROW, 
    GAME_FACT_BASKET_STOP, 
    GAME_FACT_BASKET_TECHNICAL, 
    GAME_FACT_BASKET_THREEPOINTS, 
    GAME_FACT_BASKET_TIMEOUT, 
    GAME_FACT_BASKET_TWOPOINTS, 
    
    GAME_FACT_DROP, 
    GAME_FACT_ESSAI, 
    GAME_FACT_PENALITE, 
    GAME_FACT_REDCARD, 
    GAME_FACT_RUGBY_STOP, 
    GAME_FACT_SHOOTOUTPENALTY, 
    
    GAME_FACT_SOCCER_BUT,
    GAME_FACT_SOCCER_SHOT,
    GAME_FACT_SOCCER_PENALTY, 
    GAME_FACT_SOCCER_YELLOWCARD, 
    GAME_FACT_SOCCER_REDCARD, 
    GAME_FACT_SOCCER_SHOOTOUTPENALTY, 
    GAME_FACT_SOCCER_STOP, 
    GAME_FACT_START, 
    GAME_FACT_TRANSFORMATION, 

    GAME_FACT_HANDBALL_GOAL,
    GAME_FACT_HANDBALL_REDCARD,
    GAME_FACT_HANDBALL_TURNOVER,
    GAME_FACT_HANDBALL_YELLOWCARD,
    GAME_FACT_HANDBALL_TIMEOUT,
    GAME_FACT_HANDBALL_PENALTY,
    GAME_FACT_HANDBALL_TWOMIN_SUSPENSION,
    GAME_FACT_HANDBALL_SHOOTOUT,

    GAME_FACT_SOCCER_STAR,
    GAME_FACT_RUGBY_STAR

} from "../gameFact/constants"

export const getGameFactDetail = (gameFact) => {
    switch(gameFact.subId ?? gameFact.id){

        case GAME_FACT_SOCCER_BUT :
            return getSoccerButDetail
        case GAME_FACT_SOCCER_SHOOTOUTPENALTY :
            return getSoccerShoutoutPenaltyDetail
        case GAME_FACT_SOCCER_SHOOTOUTPENALTY+'_FAIL' :
            return getSoccerShoutoutPenaltyFailDetail  
        case GAME_FACT_SOCCER_PENALTY :
            return getSoccerPenaltyDetail  
        case GAME_FACT_SOCCER_SHOT :
            return getSoccerShotDetail 
        case GAME_FACT_SOCCER_YELLOWCARD : 
            return getSoccerYellowCardDetail  
        case GAME_FACT_SOCCER_REDCARD :
            return getSoccerRedCardDetail
        case GAME_FACT_SOCCER_STAR :
            return getSoccerStarDetail

        case GAME_FACT_PENALITE :
            return getRugbyPenalityDetail
        case GAME_FACT_SHOOTOUTPENALTY :
            return getRugbyShoutoutPenaltyDetail
        case GAME_FACT_SHOOTOUTPENALTY+'_FAIL' :
            return getRugbyShoutoutPenaltyFailDetail
        case GAME_FACT_TRANSFORMATION :
            return getRugbyTransformationDetail
        case GAME_FACT_ESSAI : 
            return getRugbyEssaiDetail
        case GAME_FACT_REDCARD :
            return getRugbyRedCardDetail
        case GAME_FACT_DROP :
            return getRugbyDropDetail
        case GAME_FACT_RUGBY_STAR :
            return getRugbyStarDetail

        case GAME_FACT_BASKET_FREETHROW :
            return getBasketFreeThrowDetail   
        case GAME_FACT_BASKET_TWOPOINTS :
            return getBasketTwoPointsDetail  
        case GAME_FACT_BASKET_THREEPOINTS :
            return getBasketThreePointsDetail  
        case GAME_FACT_BASKET_FAULT :
            return getBasketFaultDetail
        case GAME_FACT_BASKET_TECHNICAL :
            return getBasketTechnicalDetail
        case GAME_FACT_BASKET_TIMEOUT :
            return getBasketTimeoutDetail

        case GAME_FACT_START :
            return getStartData
        case GAME_FACT_BASKET_STOP : 
        case GAME_FACT_RUGBY_STOP : 
        case GAME_FACT_SOCCER_STOP :
            return getStopData
        case GAME_FACT_HANDBALL_GOAL:
                return (match, team, player = {_id : 0}, defaultDetail) => getHandballGoalDetail(match, team, player, defaultDetail, true);
        case GAME_FACT_HANDBALL_GOAL+'_FAIL':
            return (match, team, player = {_id : 0}, defaultDetail) => getHandballGoalDetail(match, team, player, defaultDetail, false);
        case GAME_FACT_HANDBALL_SHOOTOUT:
                return (match, team, player = {_id : 0}, defaultDetail) => getHandballGoalShootoutDetail(match, team, player, defaultDetail, true);
        case GAME_FACT_HANDBALL_SHOOTOUT+'_FAIL':
                return (match, team, player = {_id : 0}, defaultDetail) => getHandballGoalShootoutDetail(match, team, player, defaultDetail, false);
        case GAME_FACT_HANDBALL_PENALTY:
                return (match, team, player = {_id : 0}, defaultDetail) => getHandballPenaltyDetail(match, team, player, defaultDetail, true);
        case GAME_FACT_HANDBALL_PENALTY+'_FAIL':
                return (match, team, player = {_id : 0}, defaultDetail) => getHandballPenaltyDetail(match, team, player, defaultDetail, false);
        case GAME_FACT_HANDBALL_REDCARD:
            return getHandballRedCardDetail;
        case GAME_FACT_HANDBALL_YELLOWCARD:
            return getHandballYellowCardDetail;
        case GAME_FACT_HANDBALL_TURNOVER:
            return getHandballTurnoverDetail;
        case GAME_FACT_HANDBALL_TIMEOUT:
            return getHandballTimeoutDetail;
        case GAME_FACT_HANDBALL_TWOMIN_SUSPENSION:
            return getHandballSuspensionDetail;
        default :
            console.warn("Saisie rapide non fonctionnelle pour ", gameFact.id)
    }
}

export const getStopData = (match, team, player, defaultDetail) => ({
    ...defaultDetail
})

export const getStartData = (match, team, player, defaultDetail) => ({
    ...defaultDetail
})

const getDetail = (match, team, player = { _id: 0 }, defaultDetail = {}, config) => {
    const playerResolve = player._id !== 0 ? player._id : null;
    const textInfo = playerResolve ? player.lastname : team.name;

    return {
        // Assignation des valeurs avec priorité sur defaultDetail, puis config, enfin valeurs par défaut
        butSucced: defaultDetail.butSucced ?? config.butSucced ?? null,
        buteur: defaultDetail.buteur ?? playerResolve,
        transformer: defaultDetail.transformer ?? playerResolve,
        droper: defaultDetail.droper ?? playerResolve,
        penaliter: defaultDetail.penaliter ?? playerResolve,
        shoter: defaultDetail.shoter ?? playerResolve,
        player: defaultDetail.player ?? playerResolve,
        transformSucced: defaultDetail.transformSucced ?? config.transformSucced ?? null,
        penalitySucced: defaultDetail.penalitySucced ?? config.penalitySucced ?? null,
        dropSucced: defaultDetail.dropSucced ?? config.dropSucced ?? null,
        passer: defaultDetail.passeur ?? config.passeur ?? null,
        edited: defaultDetail.edited ?? config.edited ?? false,
        period: defaultDetail.period ?? match.period,
        team: defaultDetail.team ?? team._id,
        title: defaultDetail.title ?? config.title,
        text: defaultDetail.text ?? `${config.textPrefix} ${textInfo}!`,
        timer: defaultDetail.timer !== undefined ? defaultDetail.timer : (match.statusTimer === 'off' && match.timer === 0 ? 0 : Math.floor(match.timer / 60) + 1),
        reason: defaultDetail.reason ?? config.reason ?? null,
        isSucceed: defaultDetail.isSucceed ?? config.isSucceed ?? null,
    };
};

export const getSoccerButDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: 1,
        edited: true,
        title: "BUT",
        textPrefix: "But de",
    });
};

export const getSoccerShoutoutPenaltyDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: 1,
        edited: true,
        title: "TIR AU BUT",
        textPrefix: "Tir au but réussi par",
        timer: 0,
    });
};


export const getSoccerShoutoutPenaltyFailDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: 0,
        edited: true,
        title: "TIR AU BUT",
        textPrefix: "Tir au but raté par",
        timer: 0,
    });
};

export const getSoccerShotDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "TIR",
        textPrefix: "Tir cadré réussi par",
        reason: 'cadre',
    });
};

export const getSoccerPenaltyDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: 1,
        edited: true,
        title: "PENALTY",
        textPrefix: "Penalty réussi par",
    });
};

export const getSoccerYellowCardDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "CARTON JAUNE",
        textPrefix: "Carton jaune pour",
        reason: 'autres',
    });
};

export const getSoccerRedCardDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "CARTON ROUGE",
        textPrefix: "Carton rouge pour",
        reason: 'autres',
    });
};

export const getSoccerStarDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "ETOILE",
        textPrefix: "L'étoile du match est",
    });
};

export const getRugbyEssaiDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        title: "ESSAI",
        textPrefix: "Essai de",
    });
};

export const getRugbyRedCardDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "CARTON ROUGE",
        textPrefix: "Carton rouge pour",
        reason: 'autres',
    });
};

export const getRugbyTransformationDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        transformSucced: 1,
        edited: false,
        title: "TRANSFORMATION",
        textPrefix: "Transformation réussie par",
    });
};

export const getRugbyPenalityDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        penalitySucced: 1,
        edited: false,
        title: "PENALITE",
        textPrefix: "Penalité réussie par",
    });
};

export const getRugbyShoutoutPenaltyDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        penalitySucced: 1,
        edited: false,
        title: "TIR AU BUT",
        textPrefix: "Tir au but réussi par",
        timer: 0,
    });
};

export const getRugbyShoutoutPenaltyFailDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        penalitySucced: 0,
        edited: false,
        title: "TIR AU BUT",
        textPrefix: "Tir au but raté par",
        timer: 0,
    });
};

export const getRugbyDropDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        dropSucced: 1,
        edited: false,
        title: "DROP",
        textPrefix: "Drop réussi par",
    });
};

export const getRugbyStarDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "ETOILE",
        textPrefix: "L'étoile du match est",
    });
};

export const getBasketFreeThrowDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        isSucceed: 1,
        title: "LANCER FRANC",
        textPrefix: "Lancer franc de",
    });
};

export const getBasketTwoPointsDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        isSucceed: 1,
        title: "DEUX POINTS",
        textPrefix: "Deux points de",
    });
};

export const getBasketThreePointsDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        isSucceed: 1,
        title: "TROIS POINTS",
        textPrefix: "Trois points de",
    });
};

export const getBasketFaultDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        title: "FAUTE",
        textPrefix: "Faute de",
    });
};

export const getBasketTechnicalDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: false,
        title: "FAUTE TECHNIQUE",
        textPrefix: "Faute technique de",
    });
};

export const getBasketTimeoutDetail = (match, team, undefined, defaultDetail) => {
    return getDetail(match, team, undefined, defaultDetail, {
        edited: false,
        title: "TEMPS MORT",
        textPrefix: "Temps mort pour",
    });
};

//BUT normal
export const getHandballGoalDetail = (match, team, player = { _id: 0 }, defaultDetail, isSucceed) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: isSucceed ? 1 : 0,
        edited: true,
        title: "BUT",
        textPrefix: `But ${isSucceed ? "réussi" : "raté"} de`,
    });
};

//Tir au but session de tirs au but
export const getHandballGoalShootoutDetail = (match, team, player = { _id: 0 }, defaultDetail, isSucceed) => {
    return getDetail(match, team, player, defaultDetail, {
        butSucced: isSucceed ? 1 : 0,
        edited: true,
        title: "BUT",
        textPrefix: `Tir au but ${isSucceed ? "réussi" : "raté"} de`,
        timer: 0,
    });
};

// "tir au but" / Penalité
export const getHandballPenaltyDetail = (match, team, player = { _id: 0 }, defaultDetail, isSucceed) => {
    return getDetail(match, team, player, defaultDetail, {
        penalitySucced: isSucceed ? 1 : 0,
        edited: false,
        title: "PENALTY",
        textPrefix: `Penalty ${isSucceed ? "réussi" : "raté"} par`,
    });
};

export const getHandballRedCardDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "CARTON ROUGE",
        textPrefix: "Carton rouge pour",
        reason: 'autres',
    });
};

export const getHandballYellowCardDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "AVERTISSEMENT",
        textPrefix: "Avertissement pour",
        reason: 'autres',
    });
};

export const getHandballTurnoverDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "BALLE PERDUE",
        textPrefix: "Balle perdue pour",
        reason: 'autres',
    });
};

export const getHandballTimeoutDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "TEMPS MORT",
        textPrefix: "Temps mort pour",
        reason: 'autres',
    });
};

export const getHandballSuspensionDetail = (match, team, player = { _id: 0 }, defaultDetail) => {
    return getDetail(match, team, player, defaultDetail, {
        edited: true,
        title: "2 MINUTES",
        textPrefix: "2 minutes pour",
        reason: 'autres',
    });
};







